import "./styles/grid.css";
import "./styles/spacing.css";
import "./styles/app.css";
import React from 'react';
import { render } from "react-dom";
import { Router } from "react-router-dom";
import createBrowserHistory from 'history/createBrowserHistory'
import App from './app';
import Parse from 'parse';

Parse.initialize("apvrfaq", "ZMHXKd1r5C7k7K2MLWwbRhMsjEbNiVik");
Parse.serverURL = 'https://alpine-apvrfaq.herokuapp.com/api';

const history = createBrowserHistory();

const renderApp = Component =>
	render(
		<Router
			history={history}>
			<Component />
		</Router>,
		document.getElementById("root")
	);

renderApp(App);



// WEBPACK FOOTER //
// ./src/index.js